export default "__VITE_ASSET__BUON$oVf__"